(function() {
  'use strict';

  angular
    .module('quiz.quizCtrl')
    .directive('quizImageContainer', quizImageContainer)
    .directive('quizImage', quizImage);

  quizImageContainer.$inject = [];

  function quizImageContainer() {

    var directive = {
      link: linkFunc,
      controller: QuizImageContainerCtrl
    };

    return directive;

    function linkFunc(scope, element, attrs) {
      // we need to calculate the container dimensions to properly scale
      scope.containerWidth = attrs.containerWidth || element.parent().width();
      scope.containerHeight = attrs.containerHeight || element.parent().height();

      scope.$watch(attrs.posX, function(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          element.css('left', newValue);
        }
      });

      scope.$watch(attrs.posY, function(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          element.css('top', newValue);
        }
      });

      attrs.$observe('quizImageContainer', function(val) {
        var imageData = scope.$eval(val);
        scope.calculateDimensions(imageData);
      });
    }
  }

  QuizImageContainerCtrl.$inject = ['$scope', '$q'];

  function QuizImageContainerCtrl($scope, $q) {
    $scope.containerWidth = -1;
    $scope.containerHeight = -1;
    $scope.positionX = 0;
    $scope.positionY = 0;

    var imageData = {};
    var xScale = 1;
    var yScale = 1;
    var deferred = $q.defer();
    var promise = deferred.promise;

    /**
     * Calculate dimensions - we could do this through the matrix
     * translation but the math becomes more difficult it is easier just
     * to move the outer container of the scaled image.
     * @param imageData
     */
    $scope.calculateDimensions = function(val) {
      imageData = val;
      // this must have been some odd hack that was put in but we need to keep the og data
      var modifiedScale = imageData.editedImageScale > 0 ? imageData.editedImageScale : imageData.scale;

      // calculate both x and y scale based off the bounding box
      xScale = $scope.containerWidth / imageData.boundingBoxWidth;
      yScale = $scope.containerHeight / imageData.boundingBoxHeight;

      // scaler is based off x scale only
      var scaler = modifiedScale * ($scope.containerWidth / imageData.boundingBoxWidth);
      deferred.resolve(scaler);
    };

    this.position = function() {
      // bitwise round (0.5 + someval) << 0
      var left = (0.5 + (xScale * (imageData.originX > 0 ? imageData.originX : 0))) << 0;
      var top = (0.5 + (yScale * (imageData.originY > 0 ? imageData.originY : 0))) << 0;
      $scope.positionX = left;
      $scope.positionY = top;
    };

    this.getScaler = function() {
      return promise;
    };
  }

  quizImage.$inject = ['$timeout', '$window'];

  function quizImage($timeout, $window) {

    var directive = {
      require: '^quizImageContainer',
      link: linkFunc
    };

    return directive;

    function linkFunc(scope, element, attrs, quizImageContainerCtrl) {

      // TODO: We could add a spinner to the image while data is loading
      // hide the element until the data is here or you see the image snap to size
      element.hide();

      var scaler, w, h, tx, ty;

      var imgLoaded = function() {
        quizImageContainerCtrl.getScaler().then(function(value) {
          scaler = value;
          resizeImages();
        });
      };

      $timeout(function() {
        angular.element($window).trigger('resize');
      }, 200);

      angular.element($window).on('resize', resizeImages);

      function resizeImages() {
        if (!scaler) return;

        var s;

        // we have to grab the edited image's width and height to do proper transform
        w = element.width();
        h = element.height();
        tx = -(w / 2) + (w / 2 * scaler);
        ty = -(h / 2) + (h / 2 * scaler);

        // bitwise round (0.5 + someval) << 0
        tx = (0.5 + tx) << 0;
        ty = (0.5 + ty) << 0;

        s = 'matrix(' + scaler + ', 0, 0,' + scaler + ',' + tx + ', ' + ty + ')';

        element.css({
          '-webkit-transform': s,
          '-moz-transform': s,
          '-ms-transform': s, //for IE9 only
          '-o-transform': s,
          'transform': s
        });

        quizImageContainerCtrl.position();

        // TODO: Maybe do scope.apply
        $timeout(function() {
          element.show();
        });
      }

      attrs.$observe('ngSrc', function() {
        element.load(imgLoaded);
      });

      element.on('$destroy', function() {
        // cleanup the listener
        imgLoaded();
      });
    }
  }
})();
